import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default function removeFalsyProps(object) {
  if (!object) return null;
  var result = {};
  Object.entries(object).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (value) {
      result[key] = value;
    }
  });
  return result;
}